export enum EventPartnerType {
  Partner = 'partner',
  Participant = 'participant',
}
